import { State, initialState } from "@/mk2/apps/strollers/containers/Home/Home.reducers";
import { AppState } from "@/mk2/reducers";

export const getStrollersHomeState = (state: AppState): State =>
    state.containers.strollers.home || initialState;
